export const BLOG_PAGE_TYPE = {
	BLOG_HOME: 'BLOG_HOME',
	BLOG_CATEG: 'BLOG_CATEG',
	BLOG_TAG: 'BLOG_TAG',
	BLOG_ARCHIVE: 'BLOG_ARCHIVE',
	BLOG_ARTICLE: 'BLOG_ARTICLE',
} as const;

export const POSITION_TYPE = {
	START: 'START',
	CENTER: 'CENTER',
} as const;

export const ARTICLE_CARD_TYPE = {
	SMALL: 'SMALL',
	MEDIUM: 'MEDIUM',
	LARGE: 'LARGE',
} as const;

export const ARTICLE_BLOC_TYPE = {
	TEXT_BLOC: 'TEXT_BLOC',
	HTML_BLOC: 'HTML_BLOC',
	IMAGE_BLOC: 'IMAGE_BLOC',
	VIDEO_BLOC: 'VIDEO_BLOC',
	PRODUCT_CAROUSEL: 'PRODUCT_CAROUSEL',
} as const;

export const MINIMUM_IMG_SIZE = {
	WIDTH: '366',
	HEIGHT: '345',
} as const;

export const MINIMUM_IMG_SIZE_MEDIUM = {
	WIDTH: '550',
	HEIGHT: '600',
} as const;
